import FormatDateTimeRange from 'components/utils/Formatters/FormatDateTimeRange'
import React from 'react'
import styled from 'styled-components'
import { LUX_PLUS_MONTH_TAKEOVER_START_DATE, LUX_PLUS_MONTH_TAKEOVER_END_DATE, LUX_PLUS_MONTH_HIGHLIGHT_BLUE } from '../constants/luxPlusMonthTakeoverConstants'

const CustomColour = styled.b`
  color: ${LUX_PLUS_MONTH_HIGHLIGHT_BLUE};
`

function LuxPlusMonthHeroSubtitleContent() {
  return <>
    <CustomColour>
      <FormatDateTimeRange startValue={LUX_PLUS_MONTH_TAKEOVER_START_DATE} endValue={LUX_PLUS_MONTH_TAKEOVER_END_DATE} day="numeric" month="long" />
    </CustomColour>
    {' '}
    More savings, more hidden offers, more exclusive benefits.
  </>
}

export default LuxPlusMonthHeroSubtitleContent
